// extracted by extract-css-chunks-webpack-plugin
module.exports = {"a-carousel":"a-carousel___3mIcf","a-carousel__card":"a-carousel__card___3D8rB","a-carousel__controls":"a-carousel__controls___yl31R"};